import { Loading } from 'react-daisyui'

export default function LoadBig() {
  return <div>
    <Loading color='primary' />
  </div>
}
